import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/styles";
import { EditTiaowenDialogButton, DeleteDialogButton } from "../../utils";
import store from "../../../../reduxstore";
import FilterBar from "./FilterBar";

const useStyles = makeStyles(theme => ({
  root: {
    width: "98%"
  },
  table: {
    width: "100%"
  },
  tableHead: {
    backgroundColor: theme.palette.secondary.light
  },
  tableCell: {
    color: theme.palette.common.white
  },
  warningText: {
    color: theme.palette.secondary.light
  },
  filterDiv: { display: "inline-flex", alignItems: "center" },
  tableHeadCell: {
    minWidth: "100px"
  }
}));

//使用文献内容过滤
function useFilter(initValue) {
  const [filterValue, setFilterValue] = useState(initValue);

  const handleChange = name => event => {
    setFilterValue({ ...filterValue, [name]: event.target.value });
  };

  return { filterValue, handleChange };
}

const objectArrayFilter = (objectArray, filterValue) => {
  const filterFields = Object.keys(filterValue);
  let objectFiltered = [...objectArray];
  for (let index = 0; index < filterFields.length; index++) {
    const filterField = filterFields[index];

    if (filterValue[filterField] !== "" && objectFiltered.length > 0) {
      objectFiltered = objectFiltered.filter(object => {
        return object[filterField].indexOf(filterValue[filterField]) !== -1;
      });
    }
  }
  return objectFiltered;
};

//Main Component
function TiaowenList(props) {
  const classes = useStyles();
  const { tiaowens, freshData } = props;
  const { filterValue, handleChange } = useFilter({
    content: "",
    specification: "",
    wenxian_name: "",
    user_nickname: "",
    content_from: ""
  });
  const tiaowensFilterd = objectArrayFilter(tiaowens, filterValue);

  //定义表头及是否过滤
  const tableHeadTitle = [
    { columnField: "content", columnName: "条文内容", filter: true },
    { columnField: "specification", columnName: "条文注释", filter: true },
    { columnField: "content_from", columnName: "章节出处", filter: true },
    { columnField: "wenxian_name", columnName: "文献", filter: true },
    { columnField: "user_nickname", columnName: "录入人", filter: true }
  ];

  // console.log(tiaowensFilterd);
  const { account } = store.getState();
  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          {tableHeadTitle.map(({ columnField, columnName, filter }) => (
            <TableCell
              align="left"
              className={classes.tableHeadCell}
              key={columnField}
            >
              <Typography
                variant="subtitle1"
                color="textPrimary"
                className={classes.typography}
              >
                {columnName}
              </Typography>
              {filter && tiaowens.length > 1 ? (
                <>
                  <br />
                  <FilterBar
                    value={filterValue[columnField]}
                    handleChange={handleChange(columnField)}
                  />
                </>
              ) : null}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {tiaowensFilterd.length === 0
          ? null
          : tiaowensFilterd.map(tiaowen => {
              const {
                id,
                content,
                specification,
                content_from,
                wenxian_name,
                user,
                user_nickname
              } = tiaowen;
              return (
                <TableRow key={id} hover>
                  <TableCell component="th" scope="row">
                    {content}
                  </TableCell>
                  <TableCell align="left">{specification}</TableCell>
                  <TableCell align="left">{content_from}</TableCell>
                  <TableCell align="left">{`《${wenxian_name}》`}</TableCell>

                  <TableCell align="left">
                    {user_nickname} <br />
                    {account.id === user || account.role === "教师" ? (
                      <>
                        <EditTiaowenDialogButton
                          initFormValue={tiaowen}
                          freshData={data => {
                            freshData(data, "update");
                          }}
                          buttonText="修改条文"
                        />
                        <DeleteDialogButton
                          buttonText="删除条文"
                          deleteUrl={`/api/tiaowens/${id}/`}
                          freshData={() => {
                            freshData(null, "delete", id);
                          }}
                          warningText={
                            <>
                              确定删除
                              {
                                <span className={classes.warningText}>
                                  {content}
                                </span>
                              }
                              删除后将不可恢复
                            </>
                          }
                        />
                      </>
                    ) : null}
                  </TableCell>
                </TableRow>
              );
            })}
      </TableBody>
    </Table>
  );
}

export default TiaowenList;
